import ApiService from "./api.service";
export default class PromotionService extends ApiService {
    static base_url = `${super.base_url}/promotions`;

    static async validateFirstRealOrder(code, axiosInstance) {
        const response = await axiosInstance.post(
            `${this.base_url}/first-real-order-eligibility`,
            { code }
        );

        return response.data;
    }
}
